<template>
  <b-modal
    ref="my-modal"
    header-class="justify-content-center"
    centered
    hide-footer
    title="کپچا"
    no-close-on-backdrop
    no-close-on-esc
    hide-header-close
    v-model="visibility"
  >
    <!-- Voice Captcha Commented -->
    <!-- <div class="d-block direction-rtl">
      <b-row>
        <b-col
          cols="12"
          class="red-text font-size-small pb-1 font-weight-bold"
          v-if="captchaAudioUrl"
        >
          لطفا به فایل صوتی گوش دهید و کلمه ای که می شنوید را با کیبورد فارسی
          وارد کنید (کپچا صوتی)
        </b-col>

        <b-col
          cols="12"
          class="midnight-blue-text font-size-small pb-1 font-weight-bold"
          >کلمه امنیتی:
        </b-col>

        <b-col
          cols="6"
          class="d-flex justify-content-center align-items-center flex-column"
        >
          <b-form-input
            id="captchaInput"
            placeholder="کلمه امنیتی را وارد کنید"
            class="form-control mx-1"
            required
            v-model="captchaKey"
            @input="validateInput"
          ></b-form-input>
          <div
            v-if="!captchaValidation"
            class="red-text font-size-xs font-weight-bold mt-1"
          >
            فقط کاراکترهای فارسی مجاز هستند.
          </div>
        </b-col>
        <b-col
          cols="6"
          class="d-flex justify-content-center align-items-center"
        > -->
    <!-- <b-row class="flex-vertical-align mb-5">-->
    <!--              <b-col cols="10" class="d-flex justify-content-end">-->
    <!--Captcha Image-->
    <!--            <b-spinner-->
    <!--              variant="primary"-->
    <!--              v-if="getCaptchaImagePending"-->
    <!--              class="mx-5"-->
    <!--            ></b-spinner>-->
    <!--          <img
            :src="captchaImageBase64"
            width="100%"
            height="50px"
            class="border-radius-5px"
            v-if="captchaBase64"
          />-->
    <!--Captcha Image-->
    <!--              </b-col>-->
    <!--          <b-col cols="2" class="cursor-pointer" @click="getCaptchaImage">-->
    <!--            <svg-->
    <!--              xmlns="http://www.w3.org/2000/svg"-->
    <!--              width="25"-->
    <!--              height="25"-->
    <!--              fill="currentColor"-->
    <!--              class="bi bi-arrow-clockwise"-->
    <!--              viewBox="0 0 16 16"-->
    <!--            >-->
    <!--              <path-->
    <!--                fill-rule="evenodd"-->
    <!--                d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2v1z"-->
    <!--              />-->
    <!--              <path-->
    <!--                d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466z"-->
    <!--              />-->
    <!--            </svg>-->
    <!--          </b-col>-->
    <!--            </b-row> -->
    <!-- <audio
            controls
            :key="captchaAudio"
            :src="captchaAudio"
            class="fill-width"
            v-if="captchaAudio"
            preload="auto"
          ></audio>
        </b-col>
      </b-row> -->
    <!-- <b-row>
        <b-col cols="12" class="d-flex justify-content-center">
          <button
            class="modal-button"
            @click="captchaValidationRequest()"
            :disabled="!captchaValidation"
          >
            <span>ثبت</span>
          </button>
        </b-col>
      </b-row> -->
    <!-- </div> -->
    <!-- Voice Captcha Commented -->
    <div class="direction-rtl">
      <b-row>
        <b-col cols="12" class="d-flex justify-content-start">
          <span> {{ captchaImagesInfo.question }} </span>
        </b-col>
      </b-row>
      <b-row justify-center v-if="captchaImagesInfo">
        <b-col
          cols="4"
          class="pt-2 pa-2"
          v-for="(image, index) in captchaImagesInfo.images"
          :key="index"
        >
          <button
            class="captcha-image-button"
            @click="toggleImageSelection(index)"
          >
            <img
              :src="image"
              :alt="'Captcha Image ' + index"
              class="fill-width p-1 border-radius-10px"
              :class="{ selected: selectedImages.includes(index) }"
            />
          </button>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" class="d-flex justify-content-center">
          <button class="modal-button" @click="captchaValidationRequest()">
            <span> {{ $translate("submit") }}</span>
          </button>
        </b-col>
      </b-row>
    </div>
  </b-modal>
</template>

<script>
import alertHelper from "@/helper/AlertHelper";
import { mapGetters } from "vuex";

export default {
  name: "CaptchaValidationModal",
  props: {
    visibility: Boolean,
    captchaBase64: String,
    captchaAudioUrl: String,
    multiImageCaptchaInfo: Object,
  },
  data() {
    return {
      captchaKey: null,
      captchaImageBase64: null,
      captchaAudio: null,
      captchaValidation: false,
      captchaImagesInfo: null,
      selectedImages: [],

      // test base64 captcha
    };
  },

  computed: {
    ...mapGetters(["getTransactionId"]),
    multiImageCaptchaValidation() {
      const selectedCount = this.selectedImages.length;
      return selectedCount >= 2 && selectedCount <= 4;
    },
  },
  watch: {
    visibility(value) {
      if (value) {
        if (this.captchaBase64) this.setCaptchaImage(this.captchaBase64);
        else if (this.captchaAudioUrl) this.captchaAudio = this.captchaAudioUrl;
        else if (this.multiImageCaptchaInfo) {
          try {
            this.captchaImagesInfo = JSON.parse(
              this.multiImageCaptchaInfo.message
            );
            console.log(this.captchaImagesInfo);
          } catch (e) {
            console.error("Failed to parse multiImageCaptchaInfo:", e);
          }
        }
      }
    },
  },
  methods: {
    validateInput() {
      // Regular expression for Persian characters and spaces
      const persianRegex = /^[\u0600-\u06FF\s]+$/;
      this.captchaValidation = persianRegex.test(this.captchaKey);
    },
    //Submit Information
    closeModal() {
      this.clearSelectedImages();
      this.$emit("close");
    },
    setCaptchaImage(data) {
      const base64Prefix = "data:image/png;base64,";
      this.captchaImageBase64 = base64Prefix + data;
    },

    captchaValidationRequest() {
      const transactionId = this.getTransactionId;

      if (!this.multiImageCaptchaValidation) {
        alertHelper.errorAlert(
          "",
          "انتخاب حداقل دو عکس و حداکثر چهار عکس مجاز است"
        );
        return;
      }
      this.captchaKey = this.createCaptchaKeyForMultiImage();
      alertHelper.loadingAlert();
      this.$http
        .post(`shetab/${transactionId}/captcha`, { captcha: this.captchaKey })
        .then(
          (res) => {
            if (res.body.data.status == 200) {
              this.$emit("captchaIsValidSuccessEvent");
              alertHelper.successAlert();
            } else {
              alertHelper.apiErrorAlert("", res.body.data.message);
            }
            this.closeModal();
          },
          (error) => {
            alertHelper.apiErrorAlert("", error.body.message);
          }
        );
    },
    createCaptchaKeyForMultiImage() {
      const concatenatedImages = this.selectedImages.join("-");
      return concatenatedImages;
    },
    toggleImageSelection(index) {
      if (this.selectedImages.includes(index)) {
        this.selectedImages = this.selectedImages.filter((i) => i !== index);
      } else {
        if (this.selectedImages.length < 4) {
          this.selectedImages.push(index);
        } else {
          alertHelper.errorAlert("", "انتخاب حداکثر چهار عکس مجاز است");
          // Optionally, you can show a message to the user here
        }
      }
    },
    clearSelectedImages() {
      this.selectedImages = [];
    },
  },
};
</script>

<style scoped>
.selected {
  border: 2px solid dodgerblue;
}
.modal-button {
  width: 50%;
  padding: 5px;
  margin-top: 20px;
  color: #ffffff;
  border-radius: 10px;
  justify-content: center;
  display: flex;
  align-items: center;
  background-color: var(--dodger-blue);
  border: none;
}
.captcha-image-button {
  padding: 5px;
  border-radius: 15px;
  background-color: transparent;
  border: none !important;
}
</style>
